import React from 'react';
import { Link } from 'components/core/Link';
import { getSafeHref } from '../Menu';
import PropTypes from 'prop-types';
import { simpleAmenityTextMap } from 'config/amenityMap';

export const getLocationName = (storageMenu) => {
	// NOTE: Relies on storageMenu object structure.
	// Finds the first non-empty category to extract location name.
	// If storageMenu structure changes, this may need updating.
	const keys = Object.keys(storageMenu);
	for (let i = 0; i < keys.length; i++) {
		if (storageMenu[keys[i]].length > 0) {
			const city = storageMenu[keys[i]][0].text.split(', ')[0];
			return city;
		}
	}
	return '';
};

export const trimCityName = (text) => {
	const match = text.match(/,\s*([A-Z]{2})\s+(.+)$/i);
	const trimmed = match ? match[2] : text;
	return trimmed.includes('Self Storage')
		? trimmed
		: trimmed.replace(/\bStorage\b/, 'Self Storage');
};

export const getLinkText = (text, uri, category) => {
	const trimmed = trimCityName(text);
	if (category === 'Amenity') {
		const amenityKey = uri.replace(/\/+$/, '').split('/').pop();
		const amenityLabel = simpleAmenityTextMap[amenityKey];
		if (amenityLabel) return `${amenityLabel} Self Storage`;
	}
	if (category === 'Vehicle') {
		const vehicleType = trimmed.replace(/\s+Self Storage$/i, '');
		return `Self Storage for ${vehicleType}s`;
	}
	return trimmed;
};

const GeoSpecificMenu = ({ geoLocation }) => {
	const storageMenu = {
		Amenity: [...(geoLocation.amenities || [])],
		Size: [...(geoLocation.unitTypes || [])],
		Vehicle: [...(geoLocation.vehicleStorage || [])],
	};

	const location = getLocationName(storageMenu);

	return (
		<>
			{Object.keys(storageMenu).map(
				(category) =>
					storageMenu[category].length > 0 && (
						<div
							key={`${category}-column`}
							className="find-storage-column"
						>
							<div className="find-storage-heading category">
								Find {location} Self Storage by {category}
							</div>
							{storageMenu[category].map((cityLink) => (
								<Link
									key={`${category}-${cityLink.uri}`}
									className="menu-link category find-storage-link"
									href={getSafeHref(cityLink.uri)}
									rel="noopener noreferrer"
								>
									{getLinkText(
										cityLink.text,
										cityLink.uri,
										category,
									)}
								</Link>
							))}
						</div>
					),
			)}
		</>
	);
};

GeoSpecificMenu.propTypes = {
	geoLocation: PropTypes.object.isRequired,
};

export default GeoSpecificMenu;
